import React from 'react'
import { LiveProvider, LiveEditor, LiveError, LivePreview } from 'react-live'
// eslint-disable-next-line @typescript-eslint/no-var-requires
const dracula = require('prism-react-renderer').themes.dracula

export interface ILiveCode {
  title: string
  /**
   * Takes a string to load the code
   */
  code: string
  /**
   * Import component
   */
  scope?: Record<string, unknown>

  /**
   * Takes a string to output a class. Related to emotion - It lets another component style it
   */
  className?: string
}

const LiveCode: React.FC<ILiveCode> = ({ code, scope, className }) => {
  return (
    <LiveProvider code={code} scope={scope} theme={dracula}>
      <div className={className}>
        <LivePreview />
        <LiveEditor />
        <LiveError />
      </div>
    </LiveProvider>
  )
}

export default LiveCode
